import React from "react";

const Title = ({ children }) => {
  return (
    <h2 className="strategy-video-header">
      {children}
    </h2>
  );
};

export default Title;
